import { render } from "./RadioList.vue?vue&type=template&id=31b79459&scoped=true"
import script from "./RadioList.vue?vue&type=script&lang=js"
export * from "./RadioList.vue?vue&type=script&lang=js"

import "./RadioList.vue?vue&type=style&index=0&id=31b79459&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b79459"]])

export default __exports__